// This file is auto-generated by the installer.
import xetuxConfigEvalConditionCallback from 'plugins/xetux-config/evalConditionCallback';
import toastConfigEvalConditionCallback from 'plugins/toast-config/evalConditionCallback';
import xetuxConfigEvalCondition from 'plugins/xetux-config/types/EvalCondition';
import toastConfigEvalCondition from 'plugins/toast-config/types/EvalCondition';
import HashTable from 'core/interfaces/HashTable';
import PreSurveyConditionEvalCallback from 'core/presurvey/interfaces/PreSurveyConditionEvalCallback';

export type PluginsEvalConditionRules = xetuxConfigEvalCondition | toastConfigEvalCondition;

interface xetuxConfigEvalCondtionConfig {
 type: 'xetux-config';
 key: string;
 condition: xetuxConfigEvalCondition;
}
interface toastConfigEvalCondtionConfig {
 type: 'toast-config';
 key: string;
 condition: toastConfigEvalCondition;
}

export type PluginsEvalConditionConfigs = xetuxConfigEvalCondtionConfig | toastConfigEvalCondtionConfig;

const evalConditionDictionary: HashTable<PreSurveyConditionEvalCallback<PluginsEvalConditionRules>> = {
"xetux-config" : xetuxConfigEvalConditionCallback,
"toast-config" : toastConfigEvalConditionCallback 
}

export default evalConditionDictionary;
    
